/* LEGACY */
import cx from 'classnames';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import React, { FunctionComponent, useState } from 'react';
import {
  FieldValues,
  useFormContext,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
  UseFormTrigger,
} from 'react-hook-form';

import { PersonalData } from '../../forms/inputs-contents';
import Button from '../../../ui/button';
import IconSave from '../../../ui/icons/save';
import CarSelect from '../../../ui/v2/inputs/car-selector';
import { Text, Select } from '../../../ui/inputs/generic-input';
import { Part } from '../../../ui/v2/inputs/generic-input';
import TextInput from '../../../ui/v2/inputs/text';
import { useAppContext } from '../../../providers/app-context';

const AlertFormContent: FunctionComponent<{
  disabled: boolean;
  vehicle?: any;
  info?: any;
  subCategory?: any;
  user?: any;
  showPassword?: boolean;
}> = ({
  disabled,
  vehicle,
  info,
  subCategory,
  user,
  showPassword = false,
}) => {
    const { register,
      getValues,
      setValue,
      trigger,
      formState: { errors, isValid }, } = useFormContext();

    const { t } = useTranslation();
    const [partToDisplay, setPartToDisplay] = useState<any>(
      info?.subCategory
        ? {
          value: subCategory,
          label: info?.subCategory,
        }
        : null
    );

    return (
      <>
        {!user && (
          <div className="grid lg:grid-cols-3 gap-6 items-start">
            <div className="col-span-2">
              <PersonalData
                register={register}
                errors={errors}
                isDisabled={disabled}
                prefix=""
                showPassword={showPassword}
              />
            </div>
          </div>
        )}
        <div className="grid lg:grid-cols-3 gap-6 items-start">
          <Part
            register={register('part', {
              validate: {
                required: (v) =>
                  !getValues('reference') && !v
                    ? t('private-area:part-alerts-create.form.required-rule')
                    : undefined,
              },
            })}
            label={t('private-area:part-alerts-create.form.part.label')}
            placeholder={t(
              'private-area:part-alerts-create.form.part.placeholder'
            )}
            id={`part`}
            disabled={disabled}
            value={partToDisplay}
            error={errors?.part?.message}
            onChange={(e) => {
              setPartToDisplay(e);
              setValue('part', e?.value);
              trigger(['reference', 'brand', 'part']);
            }}
            isClearable={true}
          />
          <div className='group'>
            <TextInput
              {...register('reference', {
                validate: {
                  required: (v) =>
                    !getValues('part') && !getValues('brand') && !v
                      ? t('private-area:part-alerts-create.form.required-rule')
                      : undefined,
                },
              })}
              label={t('private-area:part-alerts-create.form.reference.label')}
              id={`reference`}
              placeholder={t(
                'private-area:part-alerts-create.form.reference.placeholder'
              )}
              disabled={disabled}
              error_messages={errors?.reference?.message ? [errors?.reference?.message] : []}
              border
              clearButton
              labelBehaviour={'default'}
            /></div>

          <Select
            {...register('schedule', { required: t('forms:errors.required') })}
            label={t('private-area:part-alerts-create.form.schedule.label')}
            id="contact-subject"
            required={true}
            placeholder={t(
              'private-area:part-alerts-create.form.schedule.placeholder'
            )}
            options={[
              {
                text: t(
                  'private-area:part-alerts-create.form.schedule.options.15d'
                ),
                value: '15d',
              },
              {
                text: t(
                  'private-area:part-alerts-create.form.schedule.options.1m'
                ),
                value: '1m',
              },
              {
                text: t(
                  'private-area:part-alerts-create.form.schedule.options.3m'
                ),
                value: '3m',
              },
              {
                text: t(
                  'private-area:part-alerts-create.form.schedule.options.6m'
                ),
                value: '6m',
              },
              {
                text: t(
                  'private-area:part-alerts-create.form.schedule.options.1y'
                ),
                value: '1y',
              },
            ]}
            disabled={disabled}
            error={errors?.schedule?.message}
          />
        </div>
        <CarSelect
          register={register}
          getValues={getValues}
          setValue={setValue}
          trigger={trigger}
          errors={errors}
          vehicle={vehicle}
        />
        <div className="grid lg:grid-cols-3 gap-6">
          <small className="lg:col-span-2 lg:py-3 px-4 lg:px-0">
            <i className="text-brand-100">*</i>{' '}
            <Trans
              i18nKey="private-area:part-alerts-create.form.info"
              components={{ b: <b /> }}
            />
          </small>
          <div className={cx('flex', 'justify-self-end w-full')}>
            <Button
              isFullWidth={true}
              variant="PRIMARY"
              type="submit"
              disabled={!isValid}
            >
              <span className="pl-2 font-bold">
                {t('private-area:part-alerts-create.form.btn')}
              </span>
            </Button>
          </div>
        </div>
      </>
    );
  };
export default AlertFormContent;
